export default __webpack_public_path__ + "static/media/fake-align.a2d637c6.svg";